/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Card,
  Divider,
  Typography,
  Table,
  Row,
  Col,
  Space,
  InputNumber,
  Modal,
} from "antd";
import { SaveFilled } from "@ant-design/icons";
import { ButtonBack } from "../../../components/button/index.js";
// import { uploadButton } from "../../../components/button/index.js";
import {
  PG,
  componentsDraggableEditable,
  componentsEditable,
  columnsDetailsEditable,
  columnsPKEditable,
} from "./model.js";
import { useLocation, useNavigate } from "react-router";
import { delay } from "../../../utils/util.js";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaBoxesPacking } from "react-icons/fa6";
import { GiMetalBar } from "react-icons/gi";
import { TbFlask } from "react-icons/tb";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../store/store.js";
import {
  bomSelector,
  addBomDetail,
  updateDetailWithIndex,
  setValue,
  setLost,
} from "../../../store/slices/ERP/bom.js";
import { formatCommaNumber } from "../../../utils/util";
// import { BACKEND_URL_MAIN } from "../../../utils/util.js";
// import Swal from "sweetalert2";
import PGservice from "../../../service/ERP/BOM.service.js";
// import OptionService from "../../../service/ERP/Options.service.js";
// import { Authenticate } from "../../../service/Authenticate.service.js";

import ModalMaterial from "../../../components/modal/ERP/material/ModalMaterial";
import ModalPK from "../../../components/modal/ERP/pk-mat-bom/ModalPKmatbom";
import ModalRdBom from "../../../components/modal/ERP/rd-bom/ModalRdBom";
import { use } from "react";

const bomservice = PGservice();
// const opService = OptionService();
// const authService = Authenticate();
const { Text, Title } = Typography;

const from = "/ERP/bom";

const resequenceRows = (rows = []) =>
  rows.map((item, index) => ({
    ...item,
    seq: index + 1,
  }));

const BomManage = () => {
  const { TextArea } = Input;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { config } = location.state || { config: null };
  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ซ่อนปุ่มบันทึก/ลบแถว */
  const isView = config?.action === "view";
  const [form] = Form.useForm();
  // const [formImage] = Form.useForm();
  const [formDetail, setFormDetail] = useState(PG);
  const [lost, setLost] = useState();
  const [openModalMaterial, setOpenModalMaterial] = useState(false);
  const [openModalPK, setOpenModalPK] = useState(false);
  const [openModalRd, setOpenModalRd] = useState(false);
  
  const [ProductValue, setProductValue] = useState({});
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 4 },
    })
  );

  const bomReducer = useSelector(bomSelector);
  const [listDetail, setListDetail] = useState([]);

  useEffect(() => {
    // setLoading(true);
    // alert(config?.product_type)
    getsupData(config.product_code, config?.product_type);
    return () => {
      form.resetFields();
    };
  }, []);

  useEffect(() => {
    if (bomReducer.length > 0) {
      const total_qty_after_lost = bomReducer.reduce(
        (sum, item) => sum + Number(item.qty * item.multiply || 0),
        0
      );
      // bomReducer.reduce(
      //             (sum, item) => sum + Number(item.qty * item.multiply || 0),
      //             0
      //           )


      const total_qty = bomReducer.reduce(
        (sum, item) => sum + Number(item.qty* item.multiply/(100-lost)*100|| 0),
        0
      );
      // bomReducer.reduce(
      //             (sum, item) =>
      //               sum +
      //               Number(item.qty/(100-lost)*100|| 0
      //               ),
      //             0
      //           )
      setFormDetail({...formDetail, total_qty_after_lost,lost, total_qty });
    }
    // setLoading(false);
  }, [bomReducer,lost]);

  const getsupData = (v, type) => {
    bomservice
      .get(v, type)
      .then(async (res) => {
        const {
          data: { header, detail ,detailPK},
        } = res.data;
        const { product_code, product_name } = header;
        // const { data, file } = res.data;

        setFormDetail(header);
        form.setFieldsValue({
          ...header,
          product_code: product_code,
          product_name: product_name,
          total_qty: header?.total_qty || 0,
          lost: header?.lost || 0,
          total_qty_after_lost: header?.total_qty_after_lost || 0,
        });
        setLost(header?.lost || 0);
        // console.log(detail);
        // let payload = detail.map((item, i) => ({
        //   ...item,
        //   seq: i + 1,
        // }));
        const payload = resequenceRows(detailPK);

        dispatch(setValue(detail));
        setListDetail(payload)

        // console.log(bomReducer);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation PG.");
      });
  };

  const handleChooseItems = (v) => {
    // console.log(v);
    const newData = (r) => {
      const newData = [...bomReducer];

      const ind = newData.findIndex((item) => ProductValue.seq === item?.seq);
      const item = newData[ind];

      newData.splice(ind, 1, {
        ...item,
        ...v,
        /* เลือกวัตถุดิบ ERP มาทดแทนแล้ว ปลดธง "ไม่พบใน ERP" ออก
           แถวจะเลิกไฮไลต์สีแดงและผ่านการตรวจตอนบันทึก */
        rd_unmatched: false,
        wt_in_process: Number(v?.qty ?? item?.qty ?? 0) * Number(v?.multiply ?? item?.multiply ?? 1),
      });
      return newData;
    };

    dispatch(setValue([...newData()]));
  };

  /* ---------- ดึงสูตรจากงาน RD (Sample Preparation) ----------
     ถ้าตารางมีรายการอยู่แล้วจะถามก่อนว่าจะทับหรือเพิ่มต่อท้าย
     แถวที่ไม่มีรหัสใน ERP (rd_unmatched) จะถูกไฮไลต์ให้ไปเลือกตัวทดแทน */
  const applyRdRows = (rows, mode) => {
    const merged =
      mode === "append" ? [...bomReducer, ...rows] : [...rows];
    dispatch(setValue(resequenceRows(merged)));

    /* ทุกแถวมี mat_code ครบตั้งแต่ในโมดัลแล้ว (บังคับเลือกทดแทนก่อนกดดึง)
       ตรงนี้แค่บอกว่ามีกี่รายการที่ใช้วัตถุดิบทดแทน ไม่ใช่รหัสเดิมจาก SP */
    const subs = rows.filter((r) => r.rd_substituted).length;
    message.success(
      subs > 0
        ? `ดึงสูตรจาก Sample Preparation เรียบร้อย (ใช้วัตถุดิบทดแทน ${subs} รายการ)`
        : "ดึงสูตรจาก Sample Preparation เรียบร้อย"
    );
  };

  const handleRdChoosed = (rows) => {
    if (!rows || rows.length === 0) return;

    if (bomReducer.length === 0) {
      applyRdRows(rows, "replace");
      return;
    }

    /* ใช้ footer เองเพราะต้องมี 3 ทางเลือก : ยกเลิก / เพิ่มต่อท้าย / ทับของเดิม
       (okText+cancelText ให้ได้แค่ 2 และแยกไม่ออกว่ากดกากบาทหรือกดปุ่ม) */
    const dlg = Modal.confirm({
      title: "ตารางมีรายการวัตถุดิบอยู่แล้ว",
      content: `มีอยู่เดิม ${bomReducer.length} รายการ · สูตรที่เลือกมี ${rows.length} รายการ`,
      icon: null,
      closable: true,
      footer: () => (
        <Flex gap={8} justify="end" style={{ marginTop: 16 }}>
          <Button onClick={() => dlg.destroy()}>ยกเลิก</Button>
          <Button
            onClick={() => {
              applyRdRows(rows, "append");
              dlg.destroy();
            }}
          >
            เพิ่มต่อท้าย
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              applyRdRows(rows, "replace");
              dlg.destroy();
            }}
          >
            ทับของเดิม
          </Button>
        </Flex>
      ),
    });
  };
  

  const handleItemsChoosed = (value) => {
    // console.log(value);
    const payload = resequenceRows(value);

    setListDetail(payload);
    // handleSummaryPrice();
  };

  const handleConfirm = () => {
    form
      .validateFields()
      .then(() => {
        if (bomReducer.length < 1) throw new Error("กรุณาเพิ่ม รายการขาย");

        /* แถวที่ดึงมาจาก RD แล้วยังไม่มีรหัสวัตถุดิบของ ERP บันทึกไม่ได้
           เพราะ er_bom.mat_code จะว่าง ทำให้ JO/คำนวณวัตถุดิบพังตามไปด้วย */
        const noMat = bomReducer.filter((r) => !r?.mat_code);
        if (noMat.length > 0) {
          message.error(
            `มี ${noMat.length} รายการที่ยังไม่ได้เลือกวัตถุดิบของ ERP (แถวสีแดง) กรุณากดช่อง Code เพื่อเลือกก่อนบันทึก`
          );
          return;
        }

        const header = {
          ...formDetail,
          product_code: form.getFieldValue("product_code"),
          product_name: form.getFieldValue("product_name"),
          total_qty: form.getFieldValue("total_qty"),
          total_qty_after_lost: form.getFieldValue("total_qty_after_lost"),
          lost: form.getFieldValue("lost"),
          remark: form.getFieldValue("remark"),
          sample_ref: form.getFieldValue("sample_ref"),
          lost: lost,
        };
        // const detail = bomReducer;

        const parm = { header, detail:bomReducer ,detailpk: listDetail };

        const actions =
          config?.action !== "create"
            ? bomservice.update(parm)
            : bomservice.create(parm);

        // console.log(bomReducer);
        actions
          .then(async (r) => {
            message.success("Request success.");
            navigate(from, { replace: true });
            await delay(300);
          })
          .catch((err) => {
            console.warn(err);
            const data = err?.response?.data;
            message.error(data?.message || "บันทึกไม่สำเร็จ");
          });
      })
      .catch((err) => {
        message.error("กรุณาเพิ่มวัตถุดิบก่อน");
      });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const handleDelete = (seq) => {
    const itemDetail = [...bomReducer];
    const newData = resequenceRows(itemDetail.filter((val) => val?.seq !== seq));

    // console.log([...newData()]);
    dispatch(setValue([...newData]));
  };

  const handleAction = (record) => {
    if (isView) return null;
    const itemDetail = [...bomReducer];
    return itemDetail.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDelete(record?.seq)}
        disabled={!record?.seq}
      />
    ) : null;
  };

  const handleDeletePK = (seq) => {
      const itemDetail = [...listDetail];
      const newData = resequenceRows(itemDetail.filter((val) => val?.seq !== seq));
      setListDetail([...newData]);
      //setItemsData([...newData]);
    };
  
    const handleActionPK = (record) => {
      if (isView) return null;
      const itemDetail = [...listDetail];
      return itemDetail.length >= 1 ? (
        <Button
          className="bt-icon"
          size="small"
          danger
          icon={
            <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
          }
          onClick={() => handleDeletePK(record?.seq)}
          disabled={!record?.seq}
        />
      ) : null;
    };

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...bomReducer];

      const ind = newData.findIndex((item) => row.seq === item?.seq);
      const item = newData[ind];

      const merged = { ...item, ...row };
      merged.wt_in_process =
        Number(merged.qty || 0) * Number(merged.multiply || 0);

      newData.splice(ind, 1, merged);
      return newData;
    };

    dispatch(setValue([...newData()]));
  };

  const handleSavePK = (row) => {
    const newData = (r) => {
      const newData = [...listDetail];

      const ind = newData.findIndex((item) => row.seq === item?.seq);
      const item = newData[ind];

      newData.splice(ind, 1, {
        ...item,
        ...row,
        seq: row.seq || newData.length + 1, // กำหนด seq ใหม่
      });
      return newData;
    };
    setListDetail([...newData()]);
  };

  const handleAdd = () => {
    const newRow = {
      seq: bomReducer.length + 1, // กำหนด seq ใหม่
      qty: 1, // ค่าเริ่มต้น
      pk_code: "", // ค่าเริ่มต้นสำหรับรหัสวัตถุดิบ
      pk_name: "", // ค่าเริ่มต้นสำหรับชื่อวัตถุดิบ
      typename: "", // ค่าเริ่มต้นสำหรับประเภท
      unit: "", // ค่าเริ่มต้นสำหรับหน่วย
    };
    // console.log(newRow);
    // console.log(payload);
    dispatch(addBomDetail(newRow));
    // console.log(bomReducer);
  };

  const handleModalSelect = (e, row) => {
    setOpenModalMaterial(true);
    setProductValue(row);
  };

  const handleMaterialDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = bomReducer.findIndex((item) => item.seq === active.id);
    const newIndex = bomReducer.findIndex((item) => item.seq === over.id);

    if (oldIndex < 0 || newIndex < 0) {
      return;
    }

    dispatch(setValue(resequenceRows(arrayMove([...bomReducer], oldIndex, newIndex))));
  };

  const handlePackagingDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = listDetail.findIndex((item) => item.seq === active.id);
    const newIndex = listDetail.findIndex((item) => item.seq === over.id);

    if (oldIndex < 0 || newIndex < 0) {
      return;
    }

    setListDetail(resequenceRows(arrayMove([...listDetail], oldIndex, newIndex)));
  };

  const column = columnsDetailsEditable(handleSave, handleModalSelect, {
    handleAction,
  });

  const columnPK = columnsPKEditable(handleSavePK, handleModalSelect, {
    handleActionPK,
  });

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>ข้อมูลหลัก</Divider>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item label="รหัสสินค้า" name="product_code">
            <Input placeholder="Enter Product Code." readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item label="ชื่อสินค้า" name="product_name">
            <Input placeholder="Enter Product Name." readOnly />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="remark" label="Remark">
            <TextArea rows={4} placeholder="Enter Remark " />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item label="Sample Ref" name="sample_ref">
            <Input placeholder="Enter Sample Ref." />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionTOP = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isView && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              บันทึก
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isView && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              บันทึก
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Materials
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          <Button
            className="bn-info-outline"
            size="default"
            style={{ display: "flex", alignItems: "center" }}
            icon={
              <TbFlask
                style={{
                  fontSize: "1.15rem",
                  marginRight: 4,
                  verticalAlign: "middle",
                  marginBottom: 2,
                }}
              />
            }
            onClick={() => setOpenModalRd(true)}
          >
            ดึงสูตรจาก Sample Preparation
          </Button>
          <Button
            className="bn-success-outline"
            size="default"
            style={{ display: "flex", alignItems: "center" }}
            icon={
              <GiMetalBar
                style={{
                  fontSize: "1.15rem",
                  marginRight: 4,
                  verticalAlign: "middle",
                  marginBottom: 2,
                }}
              />
            }
            onClick={() => handleAdd()}
          >
            Add Material
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  const TitleTablePK = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Packaging Materials
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
            <Button
              className="bn-success-outline"
              size="default"
              style={{ display: "flex", alignItems: "center" }}
              icon={
                <FaBoxesPacking
                  style={{
                    fontSize: "1rem",
                    marginRight: 4,
                    verticalAlign: "middle",
                    marginBottom: 2,
                  }}
                />
              }
              onClick={() => {
              setOpenModalPK(true);
            }}
            >
              Add Packaging Material
            </Button>
          </Col>
        </Flex>
      </Col>
    </Flex>
  );

  const TableSummary = () => {
    return bomReducer.length >= 1 ? (
      <>
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={4}>
            น้ำหนักหลังสูญเสีย(Weight After Lost)
          </Table.Summary.Cell>
          <Table.Summary.Cell
            index={1}
            colSpan={1}
            className="pe-2 text-end border-right-3"
            style={{ borderRigth: "0px solid" }}
          >
            <Text type="danger">
              {formatCommaNumber(
                bomReducer.reduce((sum, item) => sum + Number(item.qty || 0), 0)
              ,2,2)}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell
            index={1}
            colSpan={1}
            className="pe-2 text-end border-right-0"
            style={{ borderRigth: "0px solid" }}
          >
            <Text type="danger">
              {formatCommaNumber(
                bomReducer.reduce(
                  (sum, item) =>
                    sum + Number(item.qty /(item.yield/ 100) || 0),
                  0
                )
              )}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={1} className="border-right-0" />
          <Table.Summary.Cell
            index={1}
            colSpan={1}
            className="pe-2 text-end border-right-0"
          >
            <Text type="danger" style={{ textAlign: "end" }}>
              {/* { formatCommaNumber(bomReducer?.wt_total || 0)} */}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={1} className="border-right-0" />
          <Table.Summary.Cell
            index={1}
            colSpan={1}
            className="pe-2 text-end border-right-0"
            style={{ borderRigth: "0px solid" }}
          >
            <Text type="danger">
              {formatCommaNumber(
                formDetail?.total_qty_after_lost || 0,2,2
              )}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={3} className="border-right-0" />
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={5}>
            สูญเสีย
          </Table.Summary.Cell>
          <Table.Summary.Cell
            index={3}
            colSpan={5}
            className="field-edit suffix border-right-0"
          >
            <Form.Item name="lost" className="!m-0">
              <InputNumber
                style={{ height: 32, textAlign: "end", width: "100%" }}
                max={100}
                defaultValue={lost}
                value={lost}
                // onBlur={(v) => handleLostChange(v.target.value) }
                // onFocus={() => { myLost.current?.select() } }
                suffix="%"
                onChange={(v) => {
                  setLost(v);
                }}
                // ref={myLost}
                controls={false}
                className="lost-field"
              />
            </Form.Item>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={4} className="border-right-0" />
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={5}>
            น้ำหนักรวม(Total Weight)
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={4} className="border-right-0" />
          <Table.Summary.Cell
            index={1}
            colSpan={1}
            className="pe-2 text-end border-right-0"
          >
            <Text type="danger" style={{ textAlign: "end" }}>
              {formatCommaNumber(
               formDetail?.total_qty || 0,2,2
              )}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell colSpan={2} className="border-right-0" />
          <Table.Summary.Cell colSpan={2} className="border-right-0" />
        </Table.Summary.Row>
      </>
    ) : null;
  };

  return (
    <div className="bom-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
          position: "relative",
          paddingInline: "1.34rem",
        }}
        className="bom-modal"
      >
        {SectionTOP}
        <Form
          form={form}
          name="form_in_modal_add"
          layout="vertical"
          autoComplete="off"
          disabled={isView}
          initialValues={{
            modifier: "public",
          }}
        >
          <Card
            title={
              <Title style={{ marginTop: "15px" }} level={3}>
                {config?.title}
              </Title>
            }
          >
            {Detail}
          </Card>
          <Divider></Divider>
          <Card>
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", position: "relative" }}
            >
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleMaterialDragEnd}
              >
                <SortableContext
                  items={(bomReducer || []).map((item) => item.seq)}
                  strategy={verticalListSortingStrategy}
                >
                  <Table
                    title={() => TitleTable}
                    components={componentsDraggableEditable}
                    rowClassName={(record) =>
                      record?.rd_unmatched
                        ? "editable-row bom-row-unmatched"
                        : "editable-row"
                    }
                    bordered
                    dataSource={bomReducer || []}
                    columns={column}
                    pagination={false}
                    rowKey="seq"
                    scroll={{ x: "max-content" }}
                    size="small"
                    summary={(_) => TableSummary()}
                  />
                </SortableContext>
              </DndContext>
            </Space>
          </Card>
          <Card>
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", position: "relative" }}
            >
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handlePackagingDragEnd}
              >
                <SortableContext
                  items={listDetail.map((item) => item.seq)}
                  strategy={verticalListSortingStrategy}
                >
                  <Table
                    title={() => TitleTablePK}
                    components={componentsDraggableEditable}
                    rowClassName={() => "editable-row"}
                    bordered
                    dataSource={listDetail}
                    columns={columnPK}
                    pagination={false}
                    rowKey="seq"
                    scroll={{ x: "max-content" }}
                    size="small"
                    // summary={(_) => TableSummary()}
                  />
                </SortableContext>
              </DndContext>
            </Space>
          </Card>
        </Form>

        {SectionBottom}
      </Space>

      {openModalPK && (
        <ModalPK
          show={openModalPK}
          close={() => setOpenModalPK(false)}
          values={(v) => {
            handleItemsChoosed(v);
          }}
          // cuscode={form.getFieldValue("cuscode")}
          selected={listDetail}
        ></ModalPK>
      )}

      {openModalRd && (
        <ModalRdBom
          show={openModalRd}
          close={() => setOpenModalRd(false)}
          values={(rows) => handleRdChoosed(rows)}
        ></ModalRdBom>
      )}

      {openModalMaterial && (
        <ModalMaterial
          show={openModalMaterial}
          close={() => {
            setOpenModalMaterial(false);
          }}
          values={(v) => {
            handleChooseItems(v);
          }}
        ></ModalMaterial>
      )}
    </div>
  );
};

export default BomManage;
